import React from 'react';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import {formatHowLongAgoAsText} from "../../utils";

/**
 * Displays a shield and how long ago in human-readable terms (1 day ago) for the passed-in dateVerified
 * @param {*} props 
 * @author BrianCastor
 */
export const VerifiedDisplay = props => {
    if (props.dateVerified) {
        let verifiedText = `Verified ${formatHowLongAgoAsText(props.dateVerified)} ago`;
        return (
            <div style={{padding:'5px 0px'}}>
                <VerifiedUserOutlinedIcon style={{verticalAlign:'middle', fontSize:'17px', paddingRight:'5px', color:'#66b2e5'}}/><span>{verifiedText}</span>
            </div>
        );
    }
    else {
        return (
            <div style={{padding:'5px 0px'}}>
                <VerifiedUserOutlinedIcon style={{verticalAlign:'middle', fontSize:'17px', paddingRight:'5px'}}/><span>Not Verified</span>
            </div>
        );
    }
}